<div class="out">
  <iframe #iframe *ngIf="api_iframe_url" class="iframe" [src]="api_iframe_url" safe></iframe>
</div>
